import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-new-contact',
  templateUrl: './add-new-contact.component.html',
  styleUrls: ['./add-new-contact.component.css']
})
export class AddNewContactComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}